import { AnimationEventHandler, CSSProperties, useEffect, TouchEventHandler } from "react";
import Svg from "../svg/Svg";
import { Step } from "@src/blocks/order-flow/OrderFlow";
import StepGroup from "./StepGroup";

interface Props {
  children?: React.ReactNode;
  closeClicked: boolean;
  darkMode?: boolean;
  hasBack?: boolean;
  progress?: number;
  iconPath?: string;
  itemWidth?: number;
  steps?: Step[];
  stepIndex?: number;
  hasUserGate?: boolean;
  onBack?: () => any;
  onClose: () => any;
  handleTouchMove?: TouchEventHandler<HTMLElement>;
  animationCallbackOverride?: AnimationEventHandler<HTMLElement>;
}

const FullModal = ({
  closeClicked,
  darkMode,
  hasBack,
  progress,
  onBack,
  onClose,
  iconPath,
  itemWidth,
  steps,
  stepIndex,
  hasUserGate,
  ...props
}: Props) => {
  useEffect(() => {
    const className = "fm-o-full-modal--popup-visible";
    document.body.classList.add(className);
    document.documentElement.classList.add(className);

    return () => {
      document.body.classList.remove(className);
      document.documentElement.classList.remove(className);
    };
  }, []);

  const handleBack = () => {
    if (onBack) {
      onBack();
    }
  };

  const handleClose = () => {
    onClose();
  };

  const animationCallback: AnimationEventHandler<HTMLElement> = (e) => {
    if (props.animationCallbackOverride) {
      props.animationCallbackOverride(e);
      return;
    }
    if (closeClicked) {
      onClose();
    }
  };

  const handleTouchMove: TouchEventHandler<HTMLElement> = (e) => {
    if (props.handleTouchMove) props.handleTouchMove(e);
  };

  return (
    <section
      className={`tfm fm-o-full-modal fm-o-full-modal--` + (closeClicked ? "hide" : "show")}
      onAnimationEnd={animationCallback}
      onTouchMove={handleTouchMove}
    >
      <div
        className={"fm-o-full-modal__inner fm-o-full-modal__inner--" + (closeClicked ? "hide" : "show")}
        onAnimationEnd={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="fm-o-full-modal__top">
          <div className="fm-o-full-modal__icons">
            {hasBack && (
              <Svg onClick={handleBack} mainClass="fm-o-full-modal__back-icon" iconPath="#back-light" viewBoxWidth={64} viewBoxHeight={64} />
            )}
            <Svg
              onClick={handleClose}
              mainClass="fm-o-full-modal__close-icon"
              iconPath={iconPath || "#close-icon"}
              viewBoxWidth={64}
              viewBoxHeight={64}
            />
          </div>

          {progress && (
            <div className="fm-o-full-modal__track-step">
              <div className="fm-o-full-modal__progress-bar" style={{ "--progress": progress + "%" } as CSSProperties}></div>

              <div className="fm-o-full-modal__step-label">
                <StepGroup itemWidth={itemWidth || 0} steps={steps || []} stepIndex={stepIndex || 0} hasUserGate={!!hasUserGate} />
              </div>
            </div>
          )}
        </div>

        <div className={"fm-o-full-modal__wrapper" + (darkMode ? " fm-o-full-modal__wrapper--dark" : "")}>{props.children}</div>
      </div>
    </section>
  );
};

export default FullModal;
